
import { defineComponent, ref, onMounted, nextTick, onUnmounted } from "vue";
import { useRoute } from "vue-router";

import dateFormat, { timeFormat } from "@/utils/dateFormat";
import ClassIntro from "@/components/common/ClassIntro.vue";
import ClassSchCard from "@/components/common/ClassSchCard.vue";
import api from "@/api/axios";
import $ from "jquery";
import asyncLoadJs, { removeJs } from "@/hooks/useAsyncLoadJs";
import leftTime, { clearTime } from "@/hooks/useLeftTime";

export default defineComponent({
  name: "videoRealtime",
  components: {
    ClassIntro,
    ClassSchCard,
  },
  setup() {
    const route = useRoute();
    const id = route.query.id;
    const type = route.query.type;
    const intro = ref({});
    const detail = ref({});
    const courseChapterList = ref<object>([]);
    const live = ref({});

    api
      .get("/M/Discover/VideoRealtime/" + id, {
        params: {
          type: type,
        },
      })
      .then((res) => {
        const data = res.data.obj;
        intro.value = data.course;
        detail.value = data;
        courseChapterList.value = data.courseChapterList;
        live.value = data.live;
        nextTick(() => {
          asyncLoadJs("js/jquery-3.1.1.min.js", "videoRealtime").then(() => {
            if (type == "0") {
              asyncLoadJs("js/playbackSDK.js", "videoRealtime").then(() => {
                asyncLoadJs("js/livePlayBack.js", "videoRealtime");
              });
            } else {
              asyncLoadJs("js/base.js", "videoRealtime").then(() => {
                asyncLoadJs("js/liveSDK.JS", "videoRealtime").then(() => {
                  asyncLoadJs("js/videoRealtime.js", "videoRealtime");
                });
              });
            }
          });
          leftTime(data.course.liveStartTime, function (d: any) {
            if (d.status) {
                const $dateShow1 = $("#dateShow");
                $dateShow1.find(".d").html(d.d);
                $dateShow1.find(".h").html(d.h);
                $dateShow1.find(".m").html(d.m);
                $dateShow1.find(".s").html(d.s);
            }
          })
        });
      })
      .catch((err) => {
        console.log(err);
      });

    function contrast(startDate: string) {
      return new Date().getTime() - new Date(timeFormat(startDate)).getTime() < 0
        ? true
        : false;
    }

    //  切换列表菜单
    const menu = ref(["直播介绍", "互动聊天", "提问"]);
    const itemBool = ref(0);
    function selectMenu(item: string) {
      if (item == "直播介绍") {
        itemBool.value = 0;
      }
      if (item.indexOf("互动聊天") != -1) {
        itemBool.value = 1;
      }
      if (item == "提问") {
        itemBool.value = 2;
      }
    }

    // const btnGiftIcon = ref(true);
    // const btnFace = ref(true);
    // function openGifticon() {
    //     if(btnGiftIcon.value){
    //         $(".vrt-talk-list").css({
    //             "paddingBottom": "204px"
    //         })
    //         $(".vrt-talk-list-ul ul").css({
    //             "paddingBottom": "5.6rem"
    //         })
    //         $(".vrt-talk-input-wrap").css({
    //             "bottom": "154px"
    //         })
    //         btnGiftIcon.value = false;
    //     }else{
    //         $(".vrt-talk-list").css({
    //             "paddingBottom": "50px"
    //         })
    //         $(".vrt-talk-list-ul ul").css({
    //             "paddingBottom": "1.867rem"
    //         })
    //         $(".vrt-talk-input-wrap").css({
    //             "bottom": "0"
    //         })
    //         btnGiftIcon.value = true;
    //     }
    // }

    // function openFaceicon() {
    //     if (btnFace.value) {
    //         btnFace.value = false;
    //         $('.embox').show()
    //     } else {
    //         btnFace.value = true;
    //         $('.embox').hide()
    //     }
    // }

    // onMounted(() => {
    //     const vrtHeight = document.body.clientWidth * 0.5625;
    //     $(".vrt-main-video").height(vrtHeight);
    //     $(document).bind('click', function () {
    //         btnFace.value = true;
    //         btnGiftIcon.value = true;
    //         $('.embox').hide()
    //         $(".vrt-talk-list").css({
    //             "paddingBottom": "50px"
    //         })
    //         $(".vrt-talk-list-ul ul").css({
    //             "paddingBottom": "1.867rem"
    //         })
    //         $(".vrt-talk-input-wrap").css({
    //             "bottom": "0"
    //         })
    //     })
    // })


    // onMounted(() => {
    //   nextTick(() => {
    //     asyncLoadJs("js/jquery-3.1.1.min.js").then(() => {
    //       if (type == "0") {
    //         asyncLoadJs("js/playbackSDK.js").then(() => {
    //           asyncLoadJs("js/livePlayBack.js");
    //         });
    //       } else {
    //         asyncLoadJs("js/base.js").then(() => {
    //           asyncLoadJs("js/liveSDK.JS").then(() => {
    //             asyncLoadJs("js/videoRealtime.js");
    //           });
    //         });
    //       }
    //     });
    //   });
    // });

    onUnmounted(() => {
      removeJs("jquery-3.1.1.min.js")
      removeJs("base.js")
      removeJs("liveSDK.JS")
      removeJs("videoRealtime.js")
      removeJs("playbackSDK.js")
      removeJs("livePlayBack.js");
      
      removeJs("socket.io.js")
      removeJs("swfobject.js")
      removeJs("json3.min.js")
      removeJs("report.js")
      removeJs("dpc.js")
    })

    return {
      contrast,
      intro,
      courseChapterList,
      live,
      menu,
      selectMenu,
      itemBool,
      detail,
      // openGifticon,
      // openFaceicon
    };
  },
});
